import { render, staticRenderFns } from "./EhsTable.vue?vue&type=template&id=0c8ef320"
import script from "./EhsTable.vue?vue&type=script&lang=js"
export * from "./EhsTable.vue?vue&type=script&lang=js"
import style0 from "./EhsTable.vue?vue&type=style&index=0&id=0c8ef320&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports